import React, { forwardRef, useImperativeHandle, useRef } from 'react';

import {  ReceiptContainer } from './style';
import licLog from "../../assets/images/licLogo.png";
import logo from "../../assets/images/CSCLOGO.png"
import { isEmpty, numberToWords } from '../../utils/common';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import IconClose from '../../assets/images/IconClose';




const PremiumReceipt = forwardRef(({billDetails={},payDaital={},policyNo},ref) => {
 


    const receiptRef = useRef(null);
 const downloadPDF = async () => {
    const element = receiptRef?.current;
 element.classList.add("print");
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      backgroundColor: "#fff"
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf?.internal?.pageSize?.getWidth();
    const pdfHeight = (canvas?.height * pdfWidth) / canvas?.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save(`LIC_Receipt_${policyNo}.pdf`);
      element.classList.remove("print");
  };

   useImperativeHandle(ref, () => ({
    downloadPDF
  }))
   
  const [from,to] = (billDetails?.billerResponse?.billPeriod || "").split("to")


function getSingleModeFromDateRange(dateRange) {
     if(isEmpty(dateRange)) return;
  const [startStr, endStr] = dateRange.split(" to ");

  const parseDate = (str) => {
 
    const [d, m, y] = str.split("/").map(Number);
    return new Date(y, m - 1, d);
  };

  const start = parseDate(startStr);
  const end = parseDate(endStr);

  const diffInMonths =
    (end.getFullYear() - start.getFullYear()) * 12 +
    (end.getMonth() - start.getMonth());

  if (diffInMonths >= 12) return "Yearly";
  if (diffInMonths >= 6) return "Half-yearly";
  if (diffInMonths >= 3) return "Quarterly";
  if (diffInMonths >= 2) return "Two Monthly";
  if (diffInMonths >= 1) return "Monthly";

  return ""; // no valid mode
}


  return (
   <div>
  

     <div >
     
     
         <ReceiptContainer ref={receiptRef} >
        
      {/* Header */}
      <div className="header">
          <div className='headerTop'>
        <div className="left">
                 <img src={licLog} alt="" />
        <h2>(Established by the Life Insurance Corporation Act, 1956)</h2>
        </div>
        {/* <div className="middle">
              <h1>भारतीय जीवन बीमा निगम</h1>
              <h2 style={{marginTop:"10px"}}>Life Insurance Corporation of India</h2>
        </div> */}
        <div className="right">
            <img src={logo} alt="" style={{width:"100px",display:"block",marginLeft:"auto"}} />
           <div><p> CSC eGovernance Services India Ltd.</p></div>
           {/* <div><p>Branch Code: CSC153426540013</p></div> */}
          
        </div>
          </div>
        <div className="receipt-title">RENEWAL PREMIUM RECEIPT</div>
      </div>

      {/* Top Details */}
      <div className="top-info">
        <div>
          {/* <strong>Branch:</strong> Pay2mobiles<br /> */}
  
          <strong>Bill Number:</strong> {billDetails?.billerResponse?.billNumber}
        </div>
        <div className="text-right">
          <strong>Date:</strong>{from}<br />
          <strong>Next Due:</strong> {to}
        </div>
      </div>

      <div className="received-line">
        Received with Thanks from: {billDetails?.billerResponse?.customerName}
      </div>

      {/* Main Table */}
      <table>
        <thead>
          <tr>
            <th>Policy No.</th>
            <th>Details (Plan / Mode)</th>
            <th>Due Dates</th>
            <th>Description</th>
            <th className="text-right">Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td rowSpan="4" className="bold">{policyNo || "-"}
               { `( ${billDetails?.billerResponse?.customerName} )`}
            </td>
            <td>
           {billDetails?.billerResponse?.plan &&
            <>   <strong>Plan:</strong>{billDetails?.billerResponse?.plan}<br /></>
           }
              <strong>Mode:</strong>{getSingleModeFromDateRange(billDetails?.billerResponse?.billPeriod || "")}
            </td>
            <td>
              <strong>Bill Date:</strong>{billDetails?.billerResponse?.billDate}<br />
              <strong>Due Date:</strong> {billDetails?.billerResponse?.dueDate}
            </td>
            <td>Installment Premium</td>
            <td className="text-right">{billDetails?.billerResponse?.amount}</td>
          </tr>
          <tr>
            <td colSpan="2"> <strong>Date ( Time): </strong>{payDaital?.response?.txnDateTime  || "-"}</td>
            <td>CGST (Tax)</td>
            <td className="text-right">{billDetails?.billerResponse?.cgst || 0.00}</td>
          </tr>
          <tr>
            <td colSpan="2"><strong>Transaction No: </strong>{payDaital?.response?.refId}</td>
            <td>SGST/UTGST (Tax)</td>
            <td className="text-right"> {billDetails?.billerResponse?.sgst || 0.00}</td>
          </tr>
          <tr>
            <td colSpan="2"><strong>B-Connect Txn ID:</strong>{payDaital?.response?.txnReferenceId}</td>
            <td>Late Fee</td>
            <td className="text-right">{billDetails?.billerResponse?.lateFee || 0.00}</td>
          </tr>
          {/* Totals Row */}
          <tr className="bold" style={{ backgroundColor: '#f9f9f9' }}>
            <td colSpan="3"></td>
            <td>GRAND TOTAL</td>
            <td className="text-right">{billDetails?.billerResponse?.amount}</td>
          </tr>
        </tbody>
      </table>

      {/* Amount in Words */}
      <div className="amount-words">
       {numberToWords(billDetails?.billerResponse?.amount)}
      </div>

<div className='disclaimer' style={{fontSize:"12px"}}>This is a system-generated invoice for Bharat Connect  transaction processed through the authorized Bharat Connect  network. Payment confirmation is subject to final settlement by the biller.</div>
      {/* Footer */}
      <div className="footer">
        <div></div>
        <div className="text-right">
          <p>Payment Acknowledgement generated through Online</p>
          <p>Authorized Signatory</p>
        </div>
      </div>

      <div className='disclaimer'style={{fontSize:"14px",color:"#000",}}>
        LIC PREMIUM PAYMENT FACILITY IS FREE OF CONT. POLICY HOLDERS NEED NOT TO PAY ANY EXTRA AARRUNT AS SERVICE CHARGE OF RETAILELERANCHISION
      </div>

      <div className="disclaimer">
        Note: This is a computer-generated receipt representation based on transcribed data. 
        Valid subject to realization of cheque/DD.
      </div>
    </ReceiptContainer >
     </div>
   </div>
  );
});

export default PremiumReceipt;